import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Playroom } from 'src/app/admin/models/playroom.model';
import { Zone } from 'src/app/admin/models/zone.model';
import { PlayroomService } from 'src/app/admin/services/playroom.service';
import { RodjendanskezoneService } from 'src/app/admin/services/rodjendanskezone.service';
import { validateZone } from 'src/app/utils/formValidators';

@Component({
  selector: 'app-edit-birthday-zone-modal',
  templateUrl: './edit-birthday-zone-modal.component.html',
  styleUrls: ['./edit-birthday-zone-modal.component.scss'],
})
export class EditBirthdayZoneModalComponent  implements OnInit {
 
zone: Zone = new Zone()
  errMsg = '';
  playrooms$ = this.roomService.playrooms$;
  zoneNameQuery: string = '';

  maxAdultNumberQueryMin: string = '';
  maxChildNumbereQueryMin: string = ''
  maxAdultNumberQueryMax: string = ''
  maxChildNumbereQueryMax: string = ''

  roomnameQuery: string = ''
  currentPage: number = 1;
  itemsPerPage: number = 10
  messageError:string=''
  
  constructor(private modalController: ModalController, private roomService: PlayroomService, private rodjendanskezoneservice: RodjendanskezoneService) { }

  ngOnInit() {}

editZone() {

    const formValidation = validateZone(this.zone);
    this.errMsg = formValidation.errMsg;
    console.log(this.zone, 'this.zone')

    console.log(formValidation, 'formValidation')

    if (formValidation.isValid) {

      this.rodjendanskezoneservice.editZone(this.zone).subscribe(res => {


        this.rodjendanskezoneservice.getAllZone({
          currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
          ZoneNameQuery: this.zoneNameQuery, MaxChildNumbereQueryMin: this.maxChildNumbereQueryMin, MaxChildNumbereQueryMax: this.maxChildNumbereQueryMax
          , MaxAdultNumberQueryMin: this.maxAdultNumberQueryMin, MaxAdultNumberQueryMax: this.maxAdultNumberQueryMax, RoomNameQuery: this.roomnameQuery
        })


        this.dismissModal();


      }, (err) => {
           if (err.error.errors.includes('unknown-id')) {
          this.messageError = 'Greška: Tražena zona ne postoji.';
        }

        else if (err.error.errors.includes('Ponovite unosd')) {
          this.messageError = 'Greška: Podaci nisu validni - ponovite unos.';
        }

        else if (err.error.errors.includes('birthadyzone-name-already-exists')) {
          this.messageError = 'Greška: Rođendanska zona i igraonica već postoje u sistemu.';
        }
          if (err.error.errors.includes('BirthayZone is referenced')) {
          this.messageError = 'Greška: Igraonica je rezervisana - nemoguće ažuriranje';
        }

        this.errMsg = this.messageError       
      
      });
    }

  }
  dismissModal() {
    this.modalController.dismiss();
  }

  }







